var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevelopment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87,
    height: 87,
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#FFFFFF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M511 4484 c-12 -15 -21 -33 -21 -40 0 -26 23 -62 47 -73 17 -8 608 -11 2130 -11 1549 0 2116 -3 2144 -11 55 -17 108 -65 135 -123 23 -49 24 -59 24 -308 l0 -258 -385 0 -386 0 -24 -25 c-30 -30 -32 -64 -4 -99 l20 -26 390 0 389 0 0 -1282 0 -1283 -24 -51 c-27 -58 -80 -106 -135 -123 -55 -16 -4447 -16 -4502 0 -55 17 -108 65 -135 123 l-24 51 0 443 0 443 -25 24 c-31 32 -69 32 -101 0 l-25 -25 3 -462 c3 -458 3 -464 26 -520 33 -81 108 -160 190 -200 l67 -33 2275 0 2275 0 67 33 c82 40 157 119 190 200 l23 57 0 1655 0 1655 -23 57 c-33 81 -108 160 -190 200 l-67 33 -2151 3 -2152 2 -21 -26z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104 4387 c-32 -34 -60 -76 -75 -113 l-24 -59 -3 -1031 c-2 -998 -2 -1032 17 -1055 26 -32 86 -32 112 0 18 22 19 54 19 702 l0 679 1875 0 c1862 0 1875 0 1895 20 33 33 30 75 -6 108 l-25 22 -1870 0 -1869 0 0 258 c0 287 4 304 75 384 42 45 45 79 10 113 -39 40 -71 33 -131 -28z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573 4134 c-51 -25 -76 -75 -70 -137 4 -42 10 -56 40 -83 48 -44 94 -52 149 -25 53 25 78 65 78 123 0 104 -104 168 -197 122z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000 4132 c-100 -50 -96 -198 7 -244 167 -74 273 164 111 248 -36 19 -76 18 -118 -4z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1431 4133 c-124 -65 -93 -242 45 -259 73 -9 141 46 150 122 13 104 -103 186 -195 137z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1904 3192 c-7 -4 -118 -135 -248 -292 -208 -252 -235 -289 -235 -320 0 -31 25 -66 215 -295 263 -319 269 -325 300 -325 57 0 97 56 73 102 -7 12 -103 132 -213 266 -111 133 -201 247 -201 252 0 5 90 118 200 251 110 133 206 252 213 265 16 30 6 70 -21 89 -23 16 -64 20 -83 7z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2772 3183 c-27 -23 -542 -1118 -542 -1153 0 -56 75 -90 118 -52 26 22 542 1120 542 1153 0 56 -75 88 -118 52z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3130 3180 c-12 -12 -20 -33 -20 -53 0 -28 31 -70 210 -287 116 -140 210 -257 210 -260 0 -3 -94 -119 -210 -259 -180 -219 -210 -259 -210 -288 0 -63 71 -96 118 -55 34 29 455 545 470 575 10 21 12 35 4 50 -11 25 -455 566 -480 585 -24 18 -69 15 -92 -8z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551 1513 c-11 -10 -24 -32 -27 -50 -5 -26 -1 -37 19 -57 l26 -26 196 0 c182 0 196 1 215 20 33 33 30 75 -6 108 -24 21 -32 22 -213 22 -165 0 -191 -2 -210 -17z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1215 1505 c-14 -13 -25 -36 -25 -50 0 -14 11 -37 25 -50 l24 -25 296 0 c282 0 296 1 315 20 30 30 27 83 -6 109 -26 20 -38 21 -316 21 l-289 0 -24 -25z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2123 1518 c-48 -23 -51 -103 -4 -127 11 -6 78 -11 154 -11 127 0 135 1 155 23 31 33 29 80 -4 106 -24 19 -40 21 -153 20 -69 0 -136 -5 -148 -11z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2703 1518 c-48 -23 -51 -103 -4 -127 13 -7 153 -11 406 -11 l386 0 24 25 c14 13 25 36 25 50 0 14 -11 37 -25 50 l-24 25 -383 -1 c-246 0 -391 -4 -405 -11z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035 1163 c-52 -13 -72 -74 -39 -121 15 -22 20 -22 219 -22 l204 0 20 26 c36 46 22 93 -33 114 -27 10 -331 12 -371 3z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1704 1163 c-53 -11 -75 -83 -39 -123 17 -19 30 -20 305 -20 275 0 288 1 305 20 25 28 23 76 -4 103 -21 21 -28 22 -284 23 -144 1 -272 0 -283 -3z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2565 1163 c-36 -9 -55 -34 -55 -73 0 -64 16 -70 183 -70 134 0 149 2 167 20 25 25 26 71 1 101 -18 23 -26 24 -148 26 -70 1 -137 -1 -148 -4z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3144 1160 c-26 -10 -54 -48 -54 -71 0 -9 9 -28 21 -43 l20 -26 408 0 c396 0 408 1 426 20 25 28 23 76 -4 103 -21 22 -25 22 -409 24 -213 1 -397 -2 -408 -7z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4224 1156 c-48 -22 -60 -75 -24 -114 20 -21 29 -22 169 -22 136 0 149 2 166 20 25 28 23 76 -4 103 -20 20 -33 22 -149 25 -92 2 -135 -2 -158 -12z",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopment);
export default __webpack_public_path__ + "static/media/development.f1df5815c8279b3c38cff13c57098324.svg";
export { ForwardRef as ReactComponent };